import * as reportAction from '../actions/reports';
import * as reportConstants from '../constants/analytics';
import * as fetchingState from '../constants/fetchingState';
import { getAddressString } from '../extensions/addressHelper';
import { getErrorMessage } from '../constants/errorCode';

export default function (reports, action) {
    const updateReports = (newValues, type) => ({
        ...reports,
        [type]: {
            ...reports[type],
            ...newValues
        }
    });
    switch (action.type) {
        case reportAction.FETCH_POPULAR_SERVICES:
            {
                return updateReports({ fetching: fetchingState.FETCHING, error: undefined }, reportConstants.popularServicesReport);
            }
        case reportAction.SUCCESS_POPULAR_SERVICES:
            {
                return updateReports({ fetching: fetchingState.FETCHED, error: undefined, data: action.data }, reportConstants.popularServicesReport);
            }
        case reportAction.FAILURE_POPULAR_SERVICES:
            {
                return updateReports({ fetching: fetchingState.FAILED, error: getErrorMessage(action.data.error) }, reportConstants.popularServicesReport);
            }

        case reportAction.FETCH_ORDERS_REPORT:
            {
                return updateReports({ fetching: fetchingState.FETCHING, error: undefined }, reportConstants.orderStateReport);
            }
        case reportAction.SUCCESS_ORDERS_REPORT:
            {
                action.data.Orders.forEach(o => o.PickupAddressString = getAddressString(o.PickupAddress))
                return updateReports({ fetching: fetchingState.FETCHED, error: undefined, data: action.data }, reportConstants.orderStateReport);
            }
        case reportAction.FAILURE_ORDERS_REPORT:
            {
                return updateReports({ fetching: fetchingState.FAILED, error: getErrorMessage(action.data.error) }, reportConstants.orderStateReport);
            }
        case reportAction.FETCH_CATEGORY_CLICKS:
            {
                return updateReports({fetching: fetchingState.FETCHING, error: undefined}, reportConstants.popularClicksReport);
            }
        case reportAction.SUCCESS_CATEGORY_CLICKS:
            {
                return updateReports({ fetching: fetchingState.FETCHED, error: undefined, data: action.data }, reportConstants.popularClicksReport);
            }
        case reportAction.FAILURE_CATEGORY_CLICKS:
            {
                return updateReports({ fetching: fetchingState.FAILED, error: getErrorMessage(action.data.error) }, reportConstants.popularClicksReport);
            }
        case reportAction.CLEAN_REPORTS: 
        {
            updateReports({ fetching: fetchingState.INITIAL, data: [] }, reportConstants.popularServicesReport);
            updateReports({ fetching: fetchingState.INITIAL, data: [] }, reportConstants.orderStateReport);
            return updateReports({ fetching: fetchingState.INITIAL, data: [] }, reportConstants.popularClicksReport);
        }

        default:
            return reports;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/reportReducer.js